import styled from "styled-components";

export const BookingDetailInfoStyled = styled.div`
  .booking_detail_header {
    margin-bottom: 26px;
    .booking_detail_title {
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
  }

  .booking_admin_note {
    margin-bottom: 35px;
    display: flex;
    column-gap: 30px;
    .booking_admin_note_title {
      flex-basis: 250px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .booking_admin_note_text {
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .booking {
    margin-bottom: 26px;
    .booking_header {
      margin-bottom: 18px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      &.color_purple {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
      }
    }
    .booking_detail_row {
      margin-bottom: 4px;
      display: flex;
      .title {
        flex-basis: 250px;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
      .text {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        /* หมายเหตุพิมพ์อิสระ คงการขึ้นบรรทัดใหม่ และตัดคำยาว ๆ ไม่ให้ล้นจอ */
        &.note_text {
          white-space: pre-wrap;
          word-break: break-word;
        }
      }
    }
    .img_row {
      margin-bottom: 4px;
      display: flex;
      column-gap: 10px;
      img {
        width: 200px;
        height: 200px;
        object-fit: cover;
      }
    }
  }
  .booking_back_button {
    margin: auto;
    margin-top: 30px;
    max-width: 200px;
  }

  .theme_standard {
  }
`;
